export default __webpack_public_path__ + "images/15cfda8cc791d4c2dc13eb922cf9f521.png";